import imac from "./imac";
import imacPro from "./imac-pro";

export default {
	id: "desktops",
	title: "Desktops",
	width: "13em",
	height: "9em",
	items: [imac, imacPro]
};
